import { render, staticRenderFns } from "./Lifeline.vue?vue&type=template&id=dc4b7d12&scoped=true&"
import script from "./Lifeline.vue?vue&type=script&lang=js&"
export * from "./Lifeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b7d12",
  null
  
)

export default component.exports